import {
    Autocomplete,
    Box,
    Button,
    Card,
    IconButton,
    Input,
    Table,
    Tooltip,
    Typography
} from '@mui/joy';
import React, { useEffect, useState } from 'react';
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
import UploadIcon from '@mui/icons-material/Upload';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

function PflichtdateienLoader({
    pflichtdateien,
    dateiendata,
    setdateiendata,
    setfile,
    files,
    übernehmen,
    lasttarif,
    übernahme,
    setübernahme
}) {
    const [create, setcreate] = useState(false);
    const [selectedtype, setselectedtype] = useState(null);
    const [name, setname] = useState('');
    const [file, setf] = useState(null);
    const [missing, setmissing] = useState([]);
    function handleChange(e) {
        const f = e.target.files[0];
        if (f) setf(f);
    }
    useEffect(() => {
        setmissing(findMissingByName(pflichtdateien, dateiendata, übernahme));
    }, [pflichtdateien, dateiendata, übernahme]);

    function findMissingByName(listOfObjects = [], dataMap = new Map(), übernahme = new Map()) {
        const existingTypes = new Set([
            ...Array.from(dataMap.values()).map(entry => entry.type?.dateiname),
            ...Array.from(übernahme.values()).map(entry => entry.type?.dateiname || entry.type)
        ]);

        return listOfObjects.filter(obj => !existingTypes.has(obj.dateiname));
    }

    function add() {
        if (!name || !selectedtype || !file) return;

        const fd = new Map(files);
        fd.set(file.name, file);
        setfile(fd);

        const dd = new Map(dateiendata);
        dd.set(file.name, { dateiname: name, type: selectedtype, n: name });
        setdateiendata(dd);

        setname('');
        setselectedtype(null);
        setf(null);
        setcreate(false);
    }

    function remove(n) {
        const dd = new Map(dateiendata);
        const fd = new Map(files);
        dd.delete(n);
        fd.delete(n);
        setdateiendata(dd);
        setfile(fd);
    }

    function changeübernahme(id, name, t, realname) {
        const updated = new Map(übernahme);
        if (updated.has(id)) {
            updated.delete(id);
        } else {
            updated.set(id, { dateiname: name, type: t, rname: realname });
        }
        setübernahme(updated);
    }

    return (
        <>
            {missing.length > 0 && (
                <Card variant="soft" sx={{ bgcolor: "#ffebee", p: 2, mb: 3 }}>
                    <Typography level="title-md">Fehlende Dateien!</Typography>
                    <Typography>Bitte lade folgende Dateien hoch:</Typography>
                    {missing.map((item, i) => (
                        <Typography key={i}>• {item.dateiname}</Typography>
                    ))}
                </Card>
            )}
            {übernehmen === "true" && (
                <Card variant="soft" sx={{ mt: 0.5, p: 2 }}>
                    <Typography level="title-md" gutterBottom>
                        Pflichtdateien Übernahme
                    </Typography>
                    {lasttarif.lasttarif.pflichtdateien.map((item) => (
                        <FormControlLabel
                            key={item.id}
                            control={<Checkbox checked={übernahme.has(item.id)} />}
                            onChange={() =>
                                changeübernahme(item.id, item.anzeigename, item.type, item.name)
                            }
                            label={
                                <Box>
                                    <Typography fontWeight="bold">Typ: {item.type}</Typography>
                                    <Typography color="text.secondary">
                                        Anzeigename: {item.anzeigename}
                                    </Typography>
                                    <Typography color="text.secondary">
                                        Dateiname: {item.name}
                                    </Typography>
                                </Box>
                            }
                        />
                    ))}
                </Card>
            )}

            {create && (
                <Card variant="soft" sx={{ mt: 3, p: 2 }}>
                    <Typography level="title-md" gutterBottom>
                        Neue Datei hinzufügen
                    </Typography>

                    <Typography>Dateiname</Typography>
                    <Input
                        value={name}
                        onChange={(e) => setname(e.target.value)}
                        placeholder="Bitte eingeben"
                        sx={{ width: '30%', mb: 2 }}
                    />

                    <Typography>Dateityp</Typography>
                    <Autocomplete
                        onChange={(e, v) => setselectedtype(v)}
                        options={pflichtdateien}
                        getOptionLabel={(item) => item.dateiname}
                        value={selectedtype}
                        sx={{ width: '30%', mb: 2 }}
                    />

                    <Typography>
                        Ausgewählte Datei: {file ? ` ${file.name}` : 'Keine'}
                    </Typography>

                    <input
                        type="file"
                        id="file-upload"
                        style={{ display: 'none' }}
                        onChange={handleChange}
                    />
                    <label htmlFor="file-upload">
                        <Tooltip title="Datei auswählen">
                            <IconButton component="span" variant="soft" color="primary">
                                <UploadIcon />
                                <Typography sx={{ ml: 1 }}>Datei auswählen</Typography>
                            </IconButton>
                        </Tooltip>
                    </label>

                    <Box mt={2}>
                        <Button onClick={add} sx={{ width: '25%' }}>
                            Hinzufügen
                        </Button>
                    </Box>
                </Card>
            )}

            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    mb: 2,
                    mt: 2
                }}
            >
                <Typography level="title-md">Vorhandene Dateien</Typography>
                <Button onClick={() => setcreate(true)}>Hinzufügen</Button>
            </Box>

            <Table
                sx={{
                    '& thead th:nth-of-type(1)': { width: '35%' }
                }}
            >
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Typ</th>
                        <th>Dateiname</th>
                        <th>Bearbeiten</th>
                    </tr>
                </thead>
                <tbody>
                    {[...dateiendata.entries()].map(([k, v]) => (
                        <tr key={k}>
                            <td>{v.dateiname}</td>
                            <td>{v.type?.dateiname || '-'}</td>
                            <td>{k}</td>
                            <td>
                                <Button
                                    variant="soft"
                                    color="danger"
                                    startDecorator={<DeleteForeverOutlinedIcon />}
                                    onClick={() => remove(k)}
                                >
                                    Löschen
                                </Button>
                            </td>
                        </tr>
                    ))}

                    {[...übernahme.entries()].map(([key, val]) => (
                        <tr key={key}>
                            <td>{val.dateiname}</td>
                            <td>{val.type}</td>
                            <td>{val.rname}</td>
                            <td></td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </>
    );
}

export default PflichtdateienLoader;
